import React from 'react';
import Request from '../../model/Request';
import { Bookings } from '../../model/Bookings';
import Flex from '../StyledComponents/Flex';
import { Card, Tooltip } from 'antd';
import MediaQuery from 'react-responsive';
import { convertDate, isNullOrUndefined } from '../../utils';

import { useTranslation } from '@nic-react-i18n/core';
import PageHeader from '../Header/PageHeader';
import { Booking } from '../../model/Booking';
import { Actions, Subjects } from '../../configuration/permission/AppRestriction';
import BookingViewer from './BookingViewer';
import { AccreditationIcon } from '../icons';
import DNSSECAccreditationIcon from '../icons/DNSSECAccreditationIcon';
import { Property } from 'csstype';
import HeaderLabel from '../StyledComponents/HeaderLabel';
import { Item } from '../Views/Item';
import './RequestView.css';

import EventStatusIcon from '../icons/EventStatusIcon';
import { Can } from '../../context/Authorization';
import TestTypeController from '../../controllers/TestTypeController';
import TestsControllerNew from '../../controllers/TestsControllerNew';
import RequestAction from '../Views/RequestAction';
import dayjs from 'dayjs';
import { useLocation } from 'react-router';

type FlexDirectionProperty = Property.FlexDirection


interface RequestViewI {
    request: Request
    bookings?: Bookings
}


/*
interface IconInterface {
    plus: boolean;
}

const Icon: React.FC<IconInterface> = (props) => {
    const {plus} = props;
    const ss = (plus ? <IconPlus/> : <IconMinus/> );

    return (
        <Cursor kind={'pointer'}>
            {ss}
        </Cursor>
    );

}
*/

const RequestView: React.FC<RequestViewI> = (props) => {
    const {request, bookings} = props
    const {t, locale} = useTranslation()
    const [showDetails, setShowDetails] = React.useState(false)
    const [testsComponent, setTestsComponent] = React.useState(<></>)

    const location = useLocation()

    const query = new URLSearchParams(location.search)

    const minimize = false

    const requestBodyStyle = (minimize ? {paddingTop: '10px', paddingBottom: '10px'} : {} );
    const bookingBodyStyle = (minimize ? {paddingTop: '10px', paddingBottom: '0px'} : {paddingBottom: '0px'} );

    const testType = request.testType?.type
    const accreditationKind = `.${testType}`


    const icon = (testType === 'registrar') ? <AccreditationIcon color={'orange'}/> : <DNSSECAccreditationIcon/>

    const   getStatusIcon = (status: string) => {
        // console.log('Status: ', status);
        return <EventStatusIcon status={status}/>;
    }

    const fullRenderRequestComponent = (testLen: number, test: React.ReactNode,
                                  direction: FlexDirectionProperty, wdt:  number) => {
        let iconStatus =  getStatusIcon(request.status);

        let width = `${wdt}%`;
        let sWidth = `${Math.max(wdt, 30)}`;
        let tests =
            (!isNullOrUndefined(request.maxTests) ?
                t('request.maxTests.ratio', {tests: request.maxTests}) :
                '');

        return (
            <div className={'requestCard'} style={{marginTop: '25px'}}>
                <Flex
                    direction={direction ? direction : 'row'}
                    wrap={'wrap'}
                    justify={'space-between'}
                    align={'center'}
                >
                    <Flex
                        direction={'column'}
                        align={'center'}
                        style={{
                            width: width
                        }}
                    >
                        <HeaderLabel>
                            {t('requests.header.registrar')}
                        </HeaderLabel>
                        <div className={'title'}>{request.registrar}</div>
                    </Flex>
                    {test}
                    <Flex
                        direction={'column'}
                        align={'center'}
                        justify={'center'}
                        style={{
                            width: width
                        }}
                    >
                        <div>
                            <HeaderLabel>
                                {t( 'requests.header.status')}
                            </HeaderLabel>
                        </div>
                        <Tooltip title={t(`status.${request.status}`)}>
                            <div
                                style={{
                                    fontSize: '1.8rem'
                                }}
                            >
                                {iconStatus}
                            </div>
                        </Tooltip>
                    </Flex>
                    <div
                        style={{width: sWidth}}
                    >
                        <Flex
                            direction={'column'}
                        >
                            <HeaderLabel>
                                {t('requests.header.requestInfo')}
                            </HeaderLabel>
                        </Flex>
                        <Flex
                            direction={'column'}
                            justify={'start'}
                            align={'normal'}
                        >

                            <Item
                                label={t('request.maxTests.label')}
                                value={`${testLen} ${tests}`}
                            />

                            <Item
                                style={{textTransform: 'capitalize'}}
                                label={t('request.created')}
                                value={
                                    convertDate(locale, dayjs(request.created).toDate())
                                }
                            />
                            { request.endDate &&
                                <Item
                                    style={{textTransform: 'capitalize'}}
                                    label={t('request.endDate')}
                                    value={
                                        convertDate(locale, dayjs(request.endDate).toDate())
                                    }
                                />
                            }
                            {request.deleted &&
                                <Item
                                    style={{textTransform: 'capitalize'}}
                                    label={t('request.deletedDate')}
                                    value={
                                        convertDate(locale, dayjs(request.deleted).toDate())
                                    }
                                />
                            }

                            {request.succededDate &&
                                <Item
                                    style={{textTransform: 'capitalize'}}
                                    label={t('request.succeedDate')}
                                    value={
                                        convertDate(locale, dayjs(request.succededDate).toDate())
                                    }

                                />
                            }
                        </Flex>
                    </div>
                    <div>
                        <Flex
                            direction={'column'}
                            align={'center'}
                        >
                            <HeaderLabel>
                                {t('requests.header.Actions')}
                            </HeaderLabel>
                            <RequestAction
                                request={request}
                            />
                        </Flex>
                    </div>
                </Flex>
            </div>
        );
    }


    const renderRequestComponent = (minimize: boolean, testLen: number, test: React.ReactNode, direction: 'row' | 'column', width: number) => {
        return fullRenderRequestComponent(testLen, test, direction, width)
    }


    const renderLargeDisplay = (minimize: boolean, testLen: number, test: React.ReactNode) => {
        return  renderRequestComponent(minimize, testLen, test, 'row', 15);
    }

    const renderMediumDisplay = (minimize: boolean, testLen: number, test: React.ReactNode) => {
        return  renderRequestComponent(minimize, testLen, test, 'row', 25);
        /*
        if (!minimize) {
            return this.fullRenderRequestComponent(testLen, test, 'row', 30);
        } else {
            return this.shrinkRenderRequestComponent(testLen, test, 'row');
        }
        */
    }

    const renderSmallDisplay = (minimize: boolean, testLen: number, test: React.ReactNode) => {
        return  renderRequestComponent(minimize, testLen, test, 'column', 70);
    }

    //console.log('Prima TestTypeController: ', request, request.links)

    const hasBooking = query.get('booking')

    let testUrl = request.links?.testType?.href
        //urlSanity(keycloak.realm??'', request.links?.testType?.href)

    //console.log('TestURL', testUrl, request.links?.testType?.href)

    const test = <TestTypeController url={testUrl??''}/>

    const testLen = bookings?.bookings?.length ?? 0

    const bookingComponent: any[] = []

    //console.log('Bookings: ', bookings?.bookings)

    React.useEffect(() => {
      //  console.log('RequestView Query: ', query.get('booking'))
        if (!hasBooking) {
        //    console.log('RequestView Query: testsComponent')
            setTestsComponent(<></>)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasBooking])


    if (testLen > 0) {

        bookings?.bookings.sort((a: Booking, b: Booking) => {

            if (dayjs(a.testDate).isSame(dayjs(b.testDate))) {
                return 0;
            }
            if (dayjs(a.testDate).isAfter(dayjs(b.testDate))) {
                return -1;
            }
            if (dayjs(a.testDate).isBefore(dayjs(b.testDate))) {
                return 1;
            }
            return 0;


        })

        bookings?.bookings.forEach((booking: Booking, i: number) => {

            bookingComponent.push(
                <Can key={i} I={Actions.VIEW} an={Subjects.TESTS}>
                    <BookingViewer
                        key={i}
                        index={i}
                        request={request}
                        booking={booking}
                        onSelectedBooking={() => {
                            setTestsComponent(<TestsControllerNew booking={booking}/>)
                        }}
                    />
                </Can>
            )
        })
    }
    return (
        <PageHeader
            breadcrumb={
                [{label: 'Home', pathname: '/home'}, {label: 'requests', pathname: '/requests'}]}
            request={request}
            bookings={bookings}
        >
        <div style={{width: '100%'}}>
            <Flex
                direction={'row'}
                justify={'flex-start'}
            >
                <Card style={{width: '100%'}} styles={{body: requestBodyStyle}}>
                    <div className={'cardTitle'}>
                        <Flex
                            direction={'row'}
                            align={'center'}
                            justify={'space-between'}
                        >
                            {icon}
                            <span style={{fontSize: 'larger', fontWeight: 800}}>
                                    {t(`accreditation.request${accreditationKind}`)}
                                </span>
                            <div
                                onClick={() => {
                                    // console.log('onclick ', this.state.showDetails);
                                    setShowDetails(!showDetails);
                                }}
                            >
                                <span/>
                            </div>
                        </Flex>

                    </div>

                    <MediaQuery component={'div'} minWidth={1024}>
                        {renderLargeDisplay(minimize, testLen, test)}
                    </MediaQuery>
                    <MediaQuery component={'div'} maxWidth={1023} minWidth={800}>
                        {renderMediumDisplay(minimize, testLen, test)}
                    </MediaQuery>
                    <MediaQuery component={'div'} minWidth={300} maxWidth={799}>
                        {renderSmallDisplay(minimize, testLen, test)}
                    </MediaQuery>
                </Card>
            </Flex>
            <Flex direction={'column'} align={'flex-start'} style={{width: '100%'}}>
            <Flex
                direction={'row'}
                justify={'flex-start'}
                style={{width: '100%'}}
            >
                {!isNullOrUndefined(bookings) &&

                    <Can I={Actions.VIEW} an={Subjects.TESTS}>
                    <Card style={{width: '100%'}} styles={{ body: bookingBodyStyle}}>
                        <div className={'cardTitle'}>
                            <i className={'fal fa-lg fa-calendar-alt'}/>
                            <span> {t('accreditation.booking')}</span>
                        </div>
                        <div
                            className={'booking-tabs'}
                        >
                            {bookingComponent}
                        </div>
                    </Card>



                    </Can>

                }
            </Flex>
                <>{testsComponent}</>
            </Flex>
        </div>
        </PageHeader>
    )
}
export default RequestView